import { createSlice, createAsyncThunk, createAction } from '@reduxjs/toolkit'
import { getSecretValue, updateSecretValue } from '../../api/cafmApi'

// Async thunk to fetch operation details
export const fetchSecretValueDeatils = createAsyncThunk<SecretValueResponse, string, { rejectValue: string }>(
  'SecretValue/fetchSecretValue',
  async (integation_id, { rejectWithValue }) => {
    try {
      const response = await getSecretValue(integation_id)
      return response.data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

// Async thunk to fetch operation details
export const updateSecretValueDeatils = createAsyncThunk<
  Record<string, string>,
  SecretUpdatePayload,
  { rejectValue: string }
>('SecretValue/updateSecretValue', async (payload, { rejectWithValue }) => {
  try {
    const response = await updateSecretValue(payload)
    return response.data
  } catch (error) {
    return rejectWithValue(error.message)
  }
})

export const resetSecretValue = createAction('SecretValue/reset')

export type AuthRequest = {
  url?: string
  userNameBody?: string
  passwordBody?: string
  userNameAuth?: string
  passwordAuth?: string
  headerKey?: string
  headerValue?: string
  token?: string
  auth_type?: string
  authType?: string
}

export type SecretValueResponse =
  | {
      statusCode?: number
      message?: string
      data?: AuthRequest
    }
  | AuthRequest

export type SecretUpdatePayload = {
  integration_id: string | number // Adjust type based on actual data
  auth_type: string
  info: AuthRequest
}

const initialState: {
  secretValue: SecretValueResponse
  loading: boolean
  error: string | null
  succees: boolean
} = {
  secretValue: {},
  loading: false,
  error: null,
  succees: false,
}

const SecretValueSlice = createSlice({
  name: 'SecretValue',
  initialState,
  reducers: {
    // setPrevRequest: (state, action) => {
    //   state.OpeationDetails.previous_request = action.payload
    // },
    // setInitialRequest: (state, action) => {
    //   state.OpeationDetails.initial_request = action.payload
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSecretValueDeatils.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchSecretValueDeatils.fulfilled, (state, action) => {
        state.secretValue = action.payload
        state.loading = false
      })
      .addCase(fetchSecretValueDeatils.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
      .addCase(updateSecretValueDeatils.fulfilled, (state) => {
        state.succees = true
      })
      .addCase(updateSecretValueDeatils.rejected, (state) => {
        state.succees = false
      })
      .addCase(resetSecretValue, () => {
        return initialState
      })
  },
})
// export const { setPrevRequest, setInitialRequest } = SecretValueSlice.actions
export default SecretValueSlice.reducer
